export default __webpack_public_path__ + "static/media/nick-karvounis-TkZYCXmrKK4-unsplash.ee684948.jpg";